import { useCallback, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
/** Components */
import { Container } from 'Components/Container';
import { TitleForm } from 'Components/Form/styles';
import { Row } from 'Components/Grid';

import { Details } from './Details';
/** Services */
import { addPolicy, editPolicy, getPolicyById } from 'services/policies-service';
import { getUsersGroups } from 'services/users-groups-service';
/** State Managers */
import { useAuthTenant } from 'store/auth';
import { useSelector } from 'react-redux';
/** Third Lib Modal */
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { useMutation, useQuery } from 'react-query';



export const PoliciesForm = () => {
  const { id } = useParams();
  const selectedTenant = useSelector(useAuthTenant);
  const SwalReact = withReactContent(Swal);
  const navigate = useNavigate();


  // Buscar grupos de usuários
  const { data: usersGroups = [] } = useQuery(['getUsersGroups'], async () => {
    if (selectedTenant.slug === undefined) return [];
    const result = await getUsersGroups(selectedTenant.slug);
    return result?.data?.length > 0 ? result?.data : [];
  });
  const {
    register,
    formState: { errors },
    control,
    getValues,
    setValue,
    handleSubmit,
  } = useForm({
    defaultValues: {
      name: '',
      classification: '',
      userGroups: [],
      description: '',
      companyKey: selectedTenant.slug,
    },
  });

  const mutation = useMutation(
    () => {
      return id ? editPolicy(id, formatForm(getValues())) : addPolicy(formatForm(getValues()));
    },
    {
      onError: error => {
        // An error happened!
        SwalReact.fire({
          title: 'Erro!',
          html: error.response.data.message || error.message,
          icon: 'error',
        });
      },
      onSuccess: data => {
        const policyId = id || data.data.id;
        navigate(`/policies/show/${policyId}`);
      },
    },
  );

  const formatForm = data => {
    return {
      ...data,
      userGroups: data.userGroups.length
        ? data.userGroups.map(userGroupId => {
            // Buscar o objeto completo do grupo de usuários pelo ID
            const userGroup = usersGroups.find(group => group._id === userGroupId);
            if (userGroup) {
              return {
                _id: userGroup._id,
                name: userGroup.name,
                active: userGroup.active,
                companyKey: userGroup.companyKey,
              };
            }
            // Fallback caso não encontre o grupo
            return {
              _id: userGroupId,
              name: '',
              active: true,
              companyKey: selectedTenant.slug,
            };
          })
        : [],
    };
  };

  const handleComplete = async () => {
    mutation.mutate();
  };



  const getTitleStep = () => {
    return (
      <Row>
        <TitleForm>Detalhes</TitleForm>
      </Row>
    );
  };

  const getPolicy = useCallback(async () => {
    if (id) {
      try {
        const resPolicy = await getPolicyById(id);
        Object.keys(resPolicy.data).forEach(key => {
          if (key === 'userGroups') {
            // Transformar array de objetos em array de IDs
            const userGroupIds = resPolicy.data[key]?.map(group => group._id) || [];
            setValue(key, userGroupIds);
          } else {
            setValue(key, resPolicy.data[key]);
          }
        });
      } catch (error) {
        SwalReact.fire({
          title: 'Erro!',
          text: error.response.data.message ?? error.message,
          icon: 'error',
        });
      }
    }
  }, [id, setValue, SwalReact]);

  useEffect(() => {
    getPolicy();
  }, [getPolicy]);

  return (
    <Container title={`Políticas`} breadcrumb="Adequações / Políticas" linkPage="/policies">
      <div className="card-content w-80">
        {getTitleStep()}
        <Details
          control={control}
          register={register}
          isLoading={mutation.isLoading}
          errors={errors}
          handleComplete={handleComplete}
          handleSubmit={handleSubmit}
          id={id}
        />
      </div>
    </Container>
  );
};
